import { dataProps } from './properties'

export const setCustomerPaymentList = (state, payload) => {
    state.list = payload.response
    state.nav.total = payload.total
state.nav.page_number = payload.page_number
    if(!state.nav.had_results) {
    state.nav.had_results = payload.total>0
    }
}    

export const setCustomerPaymentData = (state, payload) => {
    state.props = payload.response    
} 

export const resetCustomerPaymentFormpartial = state => {
    state.props.paid_amount = 0
    state.props.payment_mode_id = null
}

export const resetCustomerPaymentData = state => {
    state.props = JSON.parse(JSON.stringify(dataProps))
}


// WEBPACK FOOTER //
// ./src/store/modules/customerPayment/mutations.js